import React, { Fragment, useContext } from "react";
import { Button, Result, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";

// Fallback component to display when an error occurs
function ErrorFallback() {
  // Redirect to Home Page
  const navigate = useNavigate();
  const {
    state: { homePath },
  } = useContext(AuthContext);
  const backHome = () => {
    navigate(homePath);
    if (homePath) {
      window.location.href = homePath; // This will force a full page reload to the target path
    }
  };
  if (process.env.REACT_APP_NODE_ENV === "production") {
    const iframe = document.querySelector("iframe");
    if (iframe) {
      iframe.style.display = "none";
    }
  }
  return (
    <Fragment>
      <Flex justify="center">
        <Result
          status="500"
          title="Something Went Wrong !"
          subTitle={`sorry, something went wrong`}
          extra={
            <Flex justify="center">
              <Button type="primary" onClick={backHome}>
                Back Home
              </Button>
            </Flex>
          }
        />
      </Flex>
    </Fragment>
  );
}

export default ErrorFallback;
